import React from 'react';

export default {
  width: 33,
  height: 27,
  content: (
    <path d="M12.9489 17.7948L12.403 25.3332C13.1841 25.3332 13.5223 25.0038 13.928 24.6082L17.5897 21.1725L25.1771 26.6278C26.5686 27.3892 27.549 26.9883 27.9244 25.371L32.9048 2.45888L32.9062 2.45753C33.3475 0.437945 32.1623 -0.351801 30.8065 0.143647L1.53203 11.1474C-0.465892 11.9088 -0.435641 13.0023 1.1924 13.4978L8.6767 15.7833L26.0612 5.10352C26.8794 4.57162 27.6233 4.86592 27.0114 5.39782L12.9489 17.7948Z" />
  )
};
